import { render } from "./AuftraegeSelfService.vue?vue&type=template&id=590d37da"
import script from "./AuftraegeSelfService.vue?vue&type=script&lang=js"
export * from "./AuftraegeSelfService.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__